// src/components/brandCustomization/EmailCustomization/EmailTemplateCard.jsx
import React, { useState } from 'react';
import {
    FaEnvelope,
    FaUserTie,
    FaUsers,
    FaUserClock
} from 'react-icons/fa';
import { CustomizationCard, SaveResetButtons, PreviewModal } from '../shared';
import EmailVariablesList from './EmailVariablesList';
import EmailTemplateForm from './EmailTemplateForm';
import EmailStyleEditor from './EmailStyleEditor';
import { emailTemplateInfo } from '../../../utils/brandCustomization';

/**
 * EmailTemplateCard - Card completo para un email template
 */
const EmailTemplateCard = ({
    templateName,
    formData,
    onUpdate,
    onToggleActive,
    onSave,
    onReset,
    onPreview,
    isSaving,
    marca
}) => {
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [previewHtml, setPreviewHtml] = useState('');

    const info = emailTemplateInfo[templateName];
    const templateData = formData || {};

    // Iconos por tipo de template
    const icons = {
        ticketCreation: FaEnvelope,
        ticketResend: FaEnvelope,
        addFranchise: FaUserTie,
        addWorker: FaUsers,
        winback: FaUserClock
    };

    const handlePreview = async () => {
        try {
            const html = await onPreview(templateName, marca);
            setPreviewHtml(html);
            setIsPreviewOpen(true);
        } catch (error) {
            console.error('Error generando preview:', error);
        }
    };

    const handleFieldChange = (field, value) => {
        onUpdate(templateName, field, value);
    };

    const handleStyleChange = (field, value) => {
        onUpdate(templateName, `styles.${field}`, value);
    };

    return (
        <>
            <CustomizationCard
                title={info.name}
                description={info.description}
                icon={icons[templateName] || FaEnvelope}
                isActive={templateData.isActive}
                onToggleActive={() => onToggleActive(templateName)}
            >
                {/* Variables disponibles */}
                <EmailVariablesList templateName={templateName} />

                {/* Form de textos */}
                <EmailTemplateForm
                    templateName={templateName}
                    values={templateData}
                    onChange={handleFieldChange}
                />

                {/* Editor de estilos */}
                <EmailStyleEditor
                    styles={templateData.styles || {}}
                    onChange={handleStyleChange}
                />

                {/* Botones de acción */}
                <SaveResetButtons
                    onSave={() => onSave(templateName)}
                    onReset={() => onReset(templateName)}
                    onPreview={handlePreview}
                    isSaving={isSaving[templateName]}
                    hasChanges={true}
                />
            </CustomizationCard>

            {/* Preview Modal */}
            <PreviewModal
                isOpen={isPreviewOpen}
                onClose={() => setIsPreviewOpen(false)}
                title={`Vista Previa: ${info.name}`}
            >
                {previewHtml ? (
                    <iframe
                        srcDoc={previewHtml}
                        className="w-full border border-gray-200 rounded-lg"
                        style={{
                            minHeight: '600px',
                            height: 'auto',
                            width: '100%'
                        }}
                        title="Preview de email"
                    />
                ) : (
                    <div className="text-center text-gray-500 py-8">
                        Cargando preview...
                    </div>
                )}
            </PreviewModal>
        </>
    );
};

export default EmailTemplateCard;

